import axios from "axios";
import { BASE_SERVER_URL } from "../../defaults";

import { setAlert } from "../alert.js";
import { GET_ASSETS, GET_ASSET, ASSET_ERROR, DELETE_ASSET } from "../types";

// Create or update user
export const createAsset = (
  formData,
  history,
  edit = false,
  id = null
) => async dispatch => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };

    const res = await axios.post(
      "/api/content/addasset",
      { ...formData, id },
      config
    );

    dispatch({
      type: GET_ASSET,
      payload: res.data
    });

    dispatch(
      setAlert(
        edit
          ? "The Asset details have been updated successfully"
          : "The Asset was created successfully",
        "success"
      )
    );

    history.push("/asset-page");
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: ASSET_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Get posts
export const getAssets = () => async dispatch => {
  try {
    const res = await axios.get(BASE_SERVER_URL + "/api/content/asset");

    dispatch({
      type: GET_ASSETS,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: ASSET_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Get current user
export const getCurrentAsset = id => async dispatch => {
  try {
    const res = await axios.get(`/api/content/asset/${id}`);

    dispatch({
      type: GET_ASSET,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: ASSET_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Delete post
export const deleteAsset = id => async dispatch => {
  if (window.confirm("Are you sure? This can NOT be undone!")) {
    try {
      await axios.delete(`/api/content/asset/${id}`);
      dispatch({
        type: DELETE_ASSET,
        payload: id
      });

      dispatch(setAlert("The Asset has been removed", "success"));
    } catch (err) {
      console.log(err);
      dispatch({
        type: ASSET_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status }
      });
    }
  }
};
